const BACKOFFICE_SWAL = {
  customClass: {
    popup: "backoffice-swal",
    title: "backoffice-swal__title",
    htmlContainer: "backoffice-swal__body",
    icon: "backoffice-swal__icon",
    actions: "backoffice-swal__actions",
    confirmButton: "backoffice-swal__confirm",
    cancelButton: "backoffice-swal__cancel",
  },
  buttonsStyling: false,
  reverseButtons: true,
  width: "400px",
  padding: "1.25rem 1.25rem 1rem",
}

const confirmBackofficeDelete = ({
  title = "Supprimer ?",
  text = "Cette action est définitive.",
  confirmButtonText = "Supprimer",
} = {}) => {
  if (typeof Swal === "undefined") {
    return Promise.resolve(window.confirm(`${title}\n\n${text}`))
  }

  return Swal.fire({
    ...BACKOFFICE_SWAL,
    title,
    html: String(text || "").replace(/\n/g, "<br>"),
    icon: "warning",
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText: "Annuler",
  }).then((result) => result.isConfirmed)
}

// Remplace le confirm() natif de Rails UJS (data-confirm) dans le back-office.
const initBackofficeRailsConfirm = () => {
  if (typeof Rails === "undefined" || typeof Swal === "undefined") return
  if (Rails.__backofficeConfirmPatched) return
  Rails.__backofficeConfirmPatched = true

  Rails.confirm = (message, element) => {
    if (!element?.closest?.(".backoffice-body")) {
      return window.confirm(message)
    }

    // Rails UJS attend un booléen synchrone : on bloque le flux natif
    // et on rejoue l'action après confirmation SweetAlert.
    const proceed = () => {
      const confirmAttr = element.getAttribute("data-confirm")
      element.removeAttribute("data-confirm")
      element.click()
      if (confirmAttr) element.setAttribute("data-confirm", confirmAttr)
    }

    confirmBackofficeDelete({
      title: "Confirmer la suppression",
      text: message || "Cette action est définitive.",
    }).then((ok) => {
      if (ok) proceed()
    })

    return false
  }
}

export { BACKOFFICE_SWAL, confirmBackofficeDelete, initBackofficeRailsConfirm }
